export const ACTION_TYPES = {
  fetchSignatureClickMap: 'FETCH_SIGNATURE_CLICKMAP',
  fetchSignatureClickMapPending: 'FETCH_SIGNATURE_CLICKMAP_PENDING',
  fetchSignatureClickMapSuccess: 'FETCH_SIGNATURE_CLICKMAP_SUCCESS',
  fetchSignatureClickMapFailed: 'FETCH_SIGNATURE_CLICKMAP_FAILED',
}

export const fetchSignatureClickMap = (params) => ({
  type: ACTION_TYPES.fetchSignatureClickMap,
  params
})

export const fetchSignatureClickMapPending = () => ({
  type: ACTION_TYPES.fetchSignatureClickMapPending,
})

export const fetchSignatureClickMapFailed = () => ({
  type: ACTION_TYPES.fetchSignatureClickMapFailed,
})

export const fetchSignatureClickMapSuccess = (clickMap) => ({
  type: ACTION_TYPES.fetchSignatureClickMapSuccess,
  clickMap
})
